// supported languages
import c from 'highlight.js/lib/languages/c';
import css from 'highlight.js/lib/languages/css';
import go from 'highlight.js/lib/languages/go';
import java from 'highlight.js/lib/languages/java';
import javascript from 'highlight.js/lib/languages/javascript';
import json from 'highlight.js/lib/languages/json';
import php from 'highlight.js/lib/languages/php';
import plaintext from 'highlight.js/lib/languages/plaintext';
import python from 'highlight.js/lib/languages/python';
import ruby from 'highlight.js/lib/languages/ruby';
import rust from 'highlight.js/lib/languages/rust';
import sql from 'highlight.js/lib/languages/sql';
import xml from 'highlight.js/lib/languages/xml';

import { syntaxHighlightLanguages } from 'lib/lang';

import type { LanguageFn } from 'highlight.js';

type SupportedLanguage = keyof typeof syntaxHighlightLanguages;

const languages: Record<SupportedLanguage, LanguageFn> = {
  clike: c,
  css: css,
  go: go,
  markup: xml,
  java: java,
  javascript: javascript,
  json: json,
  php: php,
  python: python,
  ruby: ruby,
  rust: rust,
  sql: sql
};

// register languages
import hljs from 'highlight.js';
hljs.registerLanguage('plaintext', plaintext);

for (const [language, languageInstance] of Object.entries(languages)) {
  hljs.registerLanguage(language, languageInstance);
}

import { createLowlight } from 'lowlight';

const lowlight = createLowlight();
lowlight.register('plaintext', plaintext);

for (const [language, languageInstance] of Object.entries(languages)) {
  lowlight.register(language, languageInstance);
}

export { hljs, lowlight };
